import React, { memo } from 'react';
import PropTypes from 'prop-types';
// import { mappingAdListingFeatures, getFeatureAdByKey } from '@app/utils/adFeaturesHelpers';
// import RibbonAd from '../LabelAd';
import { styled } from 'linaria/react';
import theme from 'clad-ui/theme/chotot';
import AdAvatar from './AdAvatar/AdAvatar';
import AdThumbnail from './AdThumbnail/AdThumbnail';
import AdBody from './AdBody/AdBody';
import Styles from './AdItem.module.scss';
import commonStyle from '../commonStyle.module.scss';
const Item = /*#__PURE__*/styled("div")({
  name: "Item",
  class: "i9yvzff"
});
const AdItem = ({
  type,
  eventName,
  adInfo,
  adViewUrl,
  // mappingFeaturesAdData,
  handleClickAdView
}) => {
  const handleImplementClickAdView = event => {
    if (event && handleClickAdView) {
      switch (type) {
        case 'blog':
          handleClickAdView(adInfo, eventName, 'click_article');
          break;
        case 'agent':
          handleClickAdView(adInfo.name, eventName, 'click_shop');
          break;
        default:
          break;
      }
    }
  };
  const convertPrice = (minPrice, maxPrice) => {
    const bil = 1000000000;
    const mil = 1000000;
    if (!minPrice || !maxPrice) return '';
    // round 0.1 number
    const roundNumber = (value, div) => Math.round(value / div * 10) / 10;
    let priceShow;
    let labelShow = '';
    if (parseInt(maxPrice, 10) === -1) {
      priceShow = parseInt(minPrice, 10);
      labelShow = 'Từ';
    }
    if (parseInt(minPrice, 10) === -1) {
      priceShow = parseInt(maxPrice, 10);
      labelShow = 'Đến';
    }
    if (priceShow) {
      const priceShowString = priceShow < bil ? `${roundNumber(priceShow, mil)} triệu/m²` : `${roundNumber(priceShow, bil)} tỷ/m²`;
      return `${labelShow} ${priceShowString}`;
    }
    if (maxPrice < bil) {
      return `${roundNumber(minPrice, mil)} - ${roundNumber(maxPrice, mil)} triệu/m²`;
    }
    return `${roundNumber(minPrice, bil)} - ${roundNumber(minPrice, bil)} tỷ/m²`;
  };

  // const adFeatures = mappingAdListingFeatures(adInfo, mappingFeaturesAdData);
  // const ribbonAd = getFeatureAdByKey(adFeatures, 'ribbon');

  const saveAdButton = null;
  let imgItem = {
    url: ''
  };
  imgItem = adInfo.project_images ? adInfo.project_images.find(img => img.position === 1) : adInfo.profile_image_url;
  return <Item className={`${Styles.item} ${Styles[type]}`}>
      <div className={Styles.wrapperLink}>
        {type === 'agent' ? <AdAvatar adInfo={adInfo} adViewUrl={adViewUrl} handleClickAdView={e => handleImplementClickAdView(e)} /> : null}
        <a className={Styles.wrapperLinkHref} href={adViewUrl} onClick={e => handleImplementClickAdView(e)}>
          <AdThumbnail saveAdButton={saveAdButton} image={imgItem?.url || adInfo.image || adInfo.cover_image_url || ''} title={adInfo.project_name || adInfo.name || adInfo.title} numberOfImages={adInfo.number_of_images} adViewUrl={adViewUrl} type={type} adCategories={adInfo.categories} />
          <AdBody key={adInfo.project_oid} type={type} title={adInfo.project_name || adInfo.name || adInfo.title} intro={adInfo.intro || ''} address={adInfo.address2 || adInfo.address} projectType={adInfo.project_type} top={adInfo.top} typeName={adInfo.type_name} commonStyle={commonStyle} price={convertPrice(adInfo.price_lowest_per_m2, adInfo.price_highest_per_m2)} data={adInfo} adViewUrl={adViewUrl} lastUpdatedTime={adInfo.date} />
        </a>
      </div>
    </Item>;
};
AdItem.propTypes = {
  adViewUrl: PropTypes.string.isRequired,
  adInfo: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.array])).isRequired,
  mappingFeaturesAdData: PropTypes.shape({}),
  handleClickAdView: PropTypes.func.isRequired
};
AdItem.defaultProps = {
  mappingFeaturesAdData: {}
};
export default memo(AdItem);

require("../../../../.linaria-cache/src/components/GridAdsProject/AdItem/AdItem.linaria.module.css");